import Sellers from 'components/SellerSettings/Sellers';

export default Sellers;
